export default "__VITE_ASSET__CUAY9DXP__"